<template>
  <div
    style="
      width: 10.5in;
      height: 5in;
      background-color: wheat;
      overflow: hidden;
    "
  >
    <div
      style="
        width: 10.5in;
        height: 9in;
        background-color: white;
        overflow: hidden;
      "
    >
      <v-container
        style="
          width: 10.5in;
          height: 8in;
          overflow: hidden;
          background-color: white !important;
        "
        class="d-flex flex-column justify-start white black--text"
        id="main-matrix"
      >
        <!--//@*/*
    //    *BUS Dice Cars  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

        <div
          id="dv_defense"
          style="
            position: absolute;
            left: 0.13in;
            top: 0.5in;
            width: 10in;
            height: 0.992in;
          "
          class="white"
        >
          <div class="line4 d-flex flex-row justify-start white">
            <div
              class="tiny_num"
              :class="{
                tiny_num_invert: (index2 + 1) % 5 == 0 ? true : false,
              }"
              v-for="(number, index2) in numbers"
              :key="index2"
            >
              |{{ number }}
            </div>
          </div>
          <div class="line3 line3 d-flex flex-row justify-start white pb-4">
            <div
              class="tiny_block"
              :class="{
                tiny_block_invert: (index1 + 1) % 5 == 0 ? true : false,
              }"
              v-for="(totaldef, index1) in totaldef"
              :key="index1"
            ></div>
          </div>
          <div
            style="width: 100%"
            class="d-flex flex-row justify-space-between"
          >
            <label
              class="simple_lbl white deflblcolor ml-1"
              style="display: block"
            >
              To Defend</label
            >
            <v-spacer></v-spacer>
            <small class="code-size mr-2">{{ this.thiscode }}</small>
          </div>
        </div>
        <div
          id="dv_ac"
          class="white"
          style="position: absolute; left: 0.13in; top: 1.6in; width: 10in"
        >
          <div class="line4 d-flex flex-row justify-start white">
            <div
              class="tiny_num"
              :class="{
                tiny_num_invert: (index2 + 1) % 5 == 0 ? true : false,
              }"
              v-for="(number, index2) in numbers"
              :key="index2"
            >
              |{{ number }}
            </div>
          </div>
          <div class="line5 line5 d-flex flex-row justify-start white pb-4">
            <div
              class="tiny_block2"
              :class="{
                tiny_block2_invert: (index4 + 1) % 5 == 0 ? true : false,
              }"
              v-for="(AC_count, index4) in AC_count"
              :key="index4"
            ></div>
          </div>
          <div
            style="width: 100%"
            class="d-flex flex-row justify-space-between"
          >
            <label class="simple_lbl mt-2 white deflblcolor ml-1"
              >WC vs AC</label
            >
            <v-spacer></v-spacer>
            <small class="code-size mr-2">{{ this.thiscode }}</small>
          </div>
        </div>
        <!-- absb lines dasfsdaf -->
        <!-- <div
          id="dv_asb"
          class="d-flex justify start white"
          style="position: absolute; left: 0.13in; top: 2.5in; width: 10.25in"
        >
          <label class="simple_lbl mt-2 white deflblcolor"
            >Absorb/Reflect/Ablate:
          </label>
          <div class="damage_line d-flex flex-row justify-start white ml-2">
            <div
              style="
                font-weight: 800;
                font-size: 24px;
                position: relative;
                top: 8px;
              "
            >
              {{ defmtx.absb }}
            </div>
          </div>
        </div> -->

        <div
          id="defense_nameing"
          style="position: absolute; left: 0.13in; top: 2.75in; width: 10in"
        >
          <div
            id="line2_def_stats"
            class="d-flex justify-start white black--text"
          >
            <div
              class="label-pair d-flex flex-row justify-start white black--text"
            >
              <label class="biglbl deflblcolor ml-1">Stat/Base: </label>
              <article class="nameitem ml-2">
                {{ defmtx.stat_base }}
              </article>
            </div>
            <div
              class="label-pair ml-4 d-flex flex-row justify-start white black--text"
            >
              <label class="biglbl deflblcolor ml-1">Bonus:</label>
              <article class="nameitem ml-2">
                {{ defmtx.bonus }}
              </article>
            </div>
            <div
              class="label-pair ml-4 d-flex flex-row justify-start white black--text"
            >
              <label class="biglbl deflblcolor ml-1">AC:</label>
              <article class="nameitem ml-2">
                {{ defmtx.AC }}
              </article>
            </div>
            <div
              class="label-pair ml-4 d-flex flex-row justify-start white black--text"
            >
              <label class="biglbl red--text ml-2" style="font-size: 24px"
                >Absorb/Reflect/Ablate:</label
              >
              <article class="nameitem ml-2 mt-1" style="font-size: 24px">
                {{ defmtx.absb }}
              </article>
            </div>
          </div>
          <div class="line2 d-flex flex-row justify-start white black--text">
            <div class="label-pair d-flex flex-row justify-start white">
              <label class="biglbl deflblcolor ml-1" style="font-size: 1.3rem"
                >Character Name:</label
              >
              <article class="nameitem ml-2">
                {{ defmtx.name }}
              </article>
            </div>

            <div
              class="label-pair ml-6 d-flex flex-row justify-start white black--text"
            >
              <label class="biglbl" style="font-size: 1.3rem"
                >Defense Name:</label
              >
              <article class="nameitem ml-2">
                {{ defmtx.defense_name }}
              </article>
            </div>
          </div>
          <div class="line2 d-flex flex-row justify-start white black--text">
            <div
              style="width: 100%"
              class="d-flex flex-row justify-space-between"
            >
              <label class="fxtitle ml-1"
                >BETA FX Defense Matrix<sup>@</sup></label
              >
              <v-spacer></v-spacer>
              <small class="code-size mr-2">{{ this.thiscode }}</small>
            </div>
          </div>
        </div>
      </v-container>
    </div>
    <v-container
      id="btns"
      class="noprint white"
      style="
        width: 100%;
        position: absolute;
        left: 0.13in;
        top: 5.5in;
        width: 984px;
      "
    >
      <v-row>
        <v-col cols="3">
          <v-text-field
            class="ml-2"
            label="Name"
            v-model="defmtx.name"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            class="ml-2"
            label="Defense Name"
            v-model="defmtx.defense_name"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="Stat Base"
            v-model="defmtx.stat_base"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="Bonus"
            v-model="defmtx.bonus"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-text-field
            class="ml-2"
            label="AC"
            v-model="defmtx.AC"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            class="ml-2"
            label="ASB"
            v-model="defmtx.absb"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-btn color="primary" elevation="2" @click="captrue">Capture</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
@font-face {
  font-family: SuiCoward;
  src: url("Sui Coward.otf") format("opentype");
}
.code-size {
  font-size: 0.5rem;
}
.vert_pair label {
  margin-left: 4px;
  margin-right: 4px;
}
.simple_lbl {
  font-family: SuiCoward;
  font-size: 1.5rem;
}
.line0 {
  height: 84px;
  width: 100%;
  background-color: black;
}
.cut_tohit_defense {
  width: 966px;
  height: 0.5in;
  background-color: black;
}
.clrtest {
  color: #e9ebf5;
}
.biglbl {
  font-weight: 800;
}
.fxtitle {
  font-family: SuiCoward;
  font-size: 2rem;
  color: rgb(16, 78, 63);
}
.deflblcolor {
  color: rgb(16, 78, 63);
}
.label-pair label {
  font-family: SuiCoward;
  font-size: 1.1rem;
}
.label-pair article {
  color: darkblue;
  text-decoration: underline;
  font-family: SuiCoward;
  font-size: 1.5rem;
  position: relative;
  top: -4px;
}
.tiny_block {
  background-color: rgb(255, 51, 0);
  width: 0.2in;
  height: 0.2in;
  border: 1px solid #e9ebf5;
}
.tiny_block_invert {
  background-color: white;
  width: 0.2in;
  height: 0.2in;
  border: 1px solid rgb(255, 51, 0);
}
.tiny_block2 {
  background-color: rgb(38, 0, 255);
  width: 0.2in;
  height: 0.2in;
  border: 1px solid #e9ebf5;
}
.tiny_block2_invert {
  background-color: white;
  width: 0.2in;
  height: 0.2in;
  border: 1px solid rgb(38, 0, 255);
}
.tiny_num {
  width: 0.2in;
  min-width: 0.2in;
  height: 0.1in;
  font-family: "Courier New", Courier, monospace;
  font-size: 8px;
  font-weight: 600;
  color: blue;
}
.tiny_num_invert {
  color: rgb(255, 51, 0);
}
@media print {
  /* styling goes here */
  .noprint {
    display: none;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "defmtrx",
  mixins: [bus_common],
  data() {
    return {
      numbers: [],
      acanvas: {},
      defmtx: {
        name: "Orc Gaurd",
        defense_name: " Sword Parry",
        stat_base: 10,
        bonus: 5,
        AC: 4,
        absb: 6,
      },
    };
  },
  computed: {
    // damage_array() {
    //   var arr_dam = [];
    //   arr_dam.push(this.defmtx.damavg / 4);
    //   arr_dam.push(this.defmtx.damavg / 2);
    //   arr_dam.push(this.defmtx.damavg / 1.5);
    //   arr_dam.push(this.defmtx.damavg);
    //   arr_dam.push(this.defmtx.damavg * 1.5);
    //   arr_dam.push(this.defmtx.damavg * 2);
    //   arr_dam.push(this.defmtx.dammax);
    //   return arr_dam;
    // },
    thiscode() {
      return (
        this.getFirstThreeCharacters(this.defmtx.name) +
        this.generateRandomFiveDigitNumber().toString()
      );
    },
    totaldef() {
      return (
        parseInt(this.defmtx.stat_base) +
        parseInt(this.defmtx.bonus) +
        parseInt(10)
      );
    },
    AC_count() {
      return 10 + parseInt(this.defmtx.AC) * 2;
    },
  },
  methods: {
    getFirstThreeCharacters(str) {
      if (str.length < 3) {
        return str; // Return the string as is if it's less than 3 characters long
      }
      return str.substring(0, 3);
    },
    generateRandomFiveDigitNumber() {
      const min = 10000;
      const max = 99999;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    async drawToCanvas(stream) {
      const canvas = document.createElement("canvas");
      const video = document.createElement("video");
      video.srcObject = stream;

      // Play it.
      await video.play();

      // Draw one video frame to canvas.
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);

      return canvas;
    },
    async captrue() {
      var self = this;
      const mainContentArea = document.querySelector("#main-matrix");
      const cropTarget = await CropTarget.fromElement(mainContentArea);

      // Prompt user to share the tab's content.
      const stream = await navigator.mediaDevices.getDisplayMedia({
        preferCurrentTab: true,
      });
      const [track] = stream.getVideoTracks();

      // Start cropping the self-capture video track using the CropTarget <-- Magic!
      await track.cropTo(cropTarget);

      this.acanvas = await this.drawToCanvas(stream);
      // this.mrbreakpoint(this.acanvas);
      // this.acanvas.toBlob((blob) => {

      //   // See https://web.dev/patterns/files/save-a-file/ to save this blob locally.
      // });
      this.acanvas.toBlob(
        function (blob) {
          console.log(typeof blob); //let you have 'blob' here

          var blobUrl = URL.createObjectURL(blob);

          var link = document.createElement("a"); // Or maybe get it from the current document
          link.href = blobUrl;
          link.download =
            self.defmtx.name + "_" + self.thiscode + "_defmtx.png";
          link.innerHTML = "Click here to download the file";

          document.body.appendChild(link); // Or append it whereever you want
          document.querySelector("a").click(); //can add an id to be specific if multiple anchor tag, and use #id
        },
        "image/png",
        1
      ); // JPEG at 100% quality
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      for (let index = 0; index < 50; index++) {
        this.numbers.push(index + 1);
      }
      this.$store.commit("setBrandbar_show", false);
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
